import { addressArrayTransformer, addressArrayTransformerFashion } from './addressArrayTransformer';


export const addressTransformer = (response: AddressResponseType) => ({
  totalCount: response.total_count || 0,
  addresses: addressArrayTransformer(response.data || []),
});

export const addressTransformerFashion = (response: AddressResponseType) => ({
  // totalCount: response.total_count || 0,
  addresses: addressArrayTransformerFashion(response?.addresses || []),
});

export const addAddressFashionTransformer = (res:addAddressResponseType) => {
  let result = {
    success:false,
    customer_address_id: '',
  };

  if (res.status === 'success') {
    result.success = true,
    result.customer_address_id = res.response.addressId;
  }

  return result;
};

export const editAddressTransformer = (response: EditAddressResponseType) => {
  let res = {
    success: false,
    message: '',
    customerAddressId: '',
  };
  if (response.status == 'success') {
    res.success = true;
    res.message = response.message;
    res.customerAddressId = response.response.customer_address_id;
  } else {
    res.success = false;
    res.message = response.message;
  }
  return res;
};

export const editAddressFashionTransFormer = (response:EditAddressFasionResponseType)=>{
   let res = {
      success:false,
      message:'',
      customerAddressId:'',
   };
   if (response.status === 'success') {
      res.success = true,
      res.message = '',
      res.customerAddressId = response.response.addressId;
   }
   return res;
};

